module.exports = "/images/a757f71453b9ba3cc315a2fa9468745f.svg";